export default __webpack_public_path__ + "static/media/addIcon.5e21aa57.svg";